import { initialState } from "../../external/store/initialState";
import { AnyAction } from "redux";
import { ErrorMessage } from "../../external/types/errors";
import { commonActionKeys } from "src/common/actions/commonActionKeys";

export default function errorMessageReducer(
  state: ErrorMessage = initialState.errorMessage,
  action: AnyAction
): ErrorMessage {
  switch (action.type) {
    case commonActionKeys.SHOW_ERROR_MESSAGE:
      return { ...action.errorMessage };
    case commonActionKeys.DISMISS_ERROR_DIALOG:
      return {
        ...action.errorMessage,
        visible: false
      };
    case commonActionKeys.CLEAR_ERROR_MESSAGE:
      return {
        visible: false
      };
    default:
      return state;
  }
}
